import { isPlatformBrowser } from '@angular/common';
import { Component, inject, PLATFORM_ID, signal, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { getArticleBySlug } from '../../data/articles';
import { SeoService } from '../../services/seo.service';
import { createPressArticleSchema } from '../../data/structured-data';

@Component({
  selector: 'app-article',
  imports: [RouterLink],
  templateUrl: './article.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './article.scss',
})
export class Article {
  protected readonly isAnimated = signal(false);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly seoService = inject(SeoService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  protected article = getArticleBySlug(
    this.route.snapshot.paramMap.get('slug') ?? ''
  );

  constructor() {
    const pageTitle = this.article?.metaTitle ?? 'Press';
    const pageDesc = this.article?.description ?? 'Press Article';
    this.seoService.update({
      title: pageTitle,
      description: pageDesc,
      jsonLdBlocks: this.article ? [createPressArticleSchema(this.article)] : [],
      breadcrumbItems: [
        { name: 'Home', path: '/' },
        { name: 'Press', path: '/press' },
        {
          name: this.article?.breadcrumb ?? 'Article',
          path: this.router.url,
        },
      ],
    });

    if (isPlatformBrowser(this.platformId)) {
      queueMicrotask(() => this.isAnimated.set(true));
    }
  }

  protected goBack(): void {
    this.router.navigate(['/news']);
  }
}
